<template>
  <div id="app">
    <div class="main">
      <div class="container">
        <Header />
        <div class="box-row">
          <Box
            v-for="(box, index) in boxes"
            :icon="box.icon"
            :title="box.name"
            :key="index"
          ></Box>
        </div>

        <footer class="footer">
        </footer>
      </div>
    </div>

    <transition name="slide">
      <router-view :boxes="boxes" :key="$route.fullPath"></router-view>
    </transition>
  </div>
</template>

<script>
import Box from "./components/Box";
import Header from "./components/Header";

export default {
  components: {
    Header,
    Box
  },
  data() {
    return {
      boxes: [
        {
          name: "Rodzina",
          title: "rodzina",
          icon: "iconFamily"
        },
        {
          name: "Praca",
          title: "praca",
          icon: "iconJob"
        },
        {
          name: "Edukacja",
          title: "edukacja",
          icon: "iconEducation"
        },
        {
          name: "Zdrowie",
          title: "zdrowie",
          icon: "iconHealth"
        },
        {
          name: "Bezpieczeństwo",
          title: "bezpieczenstwo",
          icon: "iconSecurity"
        },
        {
          name: "Polityka Zagraniczna",
          title: "polityka-zagraniczna",
          icon: "iconDiplomacy"
        },
      ]
    };
  }
  // watch: {
  //   $route() {
  //     if (this.$route.path === "/") {
  //       document.body.classList.remove("-is-covered");
  //     } else {
  //       document.body.classList.add("-is-covered");
  //     }
  //   }
  // }
};
</script>

<style lang="scss">
@font-face {
  font-family: "Anton";
  src: url("/assets/fonts/Anton-Regular.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "Roboto Light";
  src: url("/assets/fonts/Roboto-Light.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
}

* {
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  margin: 0;
  &::after {
    content: "";
    width: 100%;
    height: 100%;
    position: fixed;
    background-color: rgba($color: #00082b, $alpha: 0.6);
    top: 0;
    left: 0;
    opacity: 0;
    transition: opacity 0.3s ease;
    pointer-events: none;
  }
}

.-is-covered {
  &::after {
    opacity: 1;
    pointer-events: none;
    z-index: 1;
  }
}

.main {
  width: 100%;
  min-height: 100vh;
  background-color: #000a38;
  background-image: url(/assets/images/jpg/bg.jpg);
  // background-size: cover;
  background-size: contain;
  background-position: top center;
  background-repeat: no-repeat;
}

.container {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  padding: 0 30px;
}

.box-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  .box__wrap {
    margin: 10px;
  }
}

.footer {
  text-align: right;
  color: #616a94;
  font-size: 14px;
  font-family: "Roboto Light", sans-serif;
  // margin: 20px 0;
  padding: 20px 0;
}

.layer__body__list {
  margin-top: 0;
  list-style-image: url("/assets/images/png/pointer.png");
}

.layer__body__element {
  font-family: "Anton", sans-serif;
  color: #f7902d;
  font-size: 20px;
  padding: 30px 35px 30px 10px;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: -90px;
    width: calc(100% + 140px);
    height: 1px;
    background-color: #d9d9d9;
  }
}

.layer__body__text {
  font-family: "Roboto Light", sans-serif;
  color: #2f2f2f;
  font-size: 14px;
  margin-top: 10px;
  margin-bottom: 0;
}

// scrollbar
.vb > .vb-dragger {
  z-index: 5;
  width: 12px;
  right: 0;
}

.vb > .vb-dragger > .vb-dragger-styler {
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transform: rotate3d(0, 0, 0, 0);
  transform: rotate3d(0, 0, 0, 0);
  -webkit-transition: background-color 100ms ease-out, margin 100ms ease-out,
    height 100ms ease-out;
  transition: background-color 100ms ease-out, margin 100ms ease-out,
    height 100ms ease-out;
  background-color: rgba(247, 144, 45, 0.5);
  margin: 5px 5px 5px 0;
  border-radius: 20px;
  height: calc(100% - 10px);
  display: block;
}

.vb.vb-scrolling-phantom > .vb-dragger > .vb-dragger-styler {
  background-color: rgba(247, 144, 45, 0.8);
}

.vb > .vb-dragger:hover > .vb-dragger-styler {
  background-color: rgba(247, 144, 45, 0.8);
  margin: 0px;
  height: 100%;
}

.vb.vb-dragging > .vb-dragger > .vb-dragger-styler {
  background-color: rgba(247, 144, 45, 0.8);
  margin: 0px;
  height: 100%;
}

.vb.vb-dragging-phantom > .vb-dragger > .vb-dragger-styler {
  background-color: rgba(247, 144, 45, 0.8);
}

@media screen and (min-width: 480px) {
}

@media screen and (min-width: 970px) {
  .container {
    width: 970px;
    padding: 0;
  }

  .layer__body__element {
    font-size: 22px;
  }

  .layer__body__text {
    font-size: 14px;
  }
}

@media screen and (min-width: 1170px) {
  .main {
    background-size: cover;
  }
  .container {
    width: 1170px;
  }

  .box-row {
    display: flex;
    flex-wrap: wrap;
    width: 80%;
    margin:0 auto;
    .box__wrap {
      &:first-child {
        margin-left: 0;
      }
      &:last-child {
        margin-right: 0;
      }
      &:nth-of-type(3) {
        margin-right: 0;
      }
      &:nth-of-type(4) {
        margin-left: 0;
      }
    }
  }

  .layer__body__element {
    font-size: 24px;
  }

  .layer__body__text {
    font-size: 16px;
  }
}

@media screen and (min-width: 1452px) {
  .container {
    width: 1452px;
  }

  .layer__body__element {
    font-size: 26px;
  }
}
</style>
